import React, { useCallback, useState } from "react";
import style from "./Patients.module.sass";
import PatientListHeader from "./PatientListHeader/PatientListHeader";
import PatientBox from "../PatientBox/PatientBox";
import List from "../List/List";
import FirstAccess from "../FirstAccess/FirstAccess";

function Patients(props) {
  const {
    assignModal,
    createPatient,
    firstAccess,
    supervisor,
    licenses,
    searchSelectOptions,
    searchPatientsPlaceholderText,
    supervisorMode
  } = props;

  const baseUrl = "/patients.json";

  // util: crea URLSearchParams a partire dall'URL corrente
  const buildParamsFromUrl = (url) => new URLSearchParams(url.split("?")[1] || "");

  // util: set robusto (rimuove la chiave se vuoto/null/undefined; oppure tienila vuota se vuoi)
  const setParam = (params, key, value, { keepEmpty = false } = {}) => {
    if (value === undefined || value === null) {
      params.delete(key);
      return;
    }
    if (value === "") {
      if (keepEmpty) params.set(key, "");
      else params.delete(key);
      return;
    }
    params.set(key, value);
  };

  // util: assicura che esista un default di ordinamento
  const setDefaultSort = (params) => {
    if (!params.get("order_by")) params.set("order_by", "last_sequence_date");
    if (!params.get("direction")) params.set("direction", "desc");
  };

  // stato iniziale con default di sort
  const initialParams = new URLSearchParams();
  initialParams.set("order_by", "last_sequence_date");
  initialParams.set("direction", "desc");

  const [queryUrl, setQueryUrl] = useState(`${baseUrl}?${initialParams.toString()}`);

  const onChangeFilter = (newOrder, search, direction) => {
    const params = buildParamsFromUrl(queryUrl);

    // aggiorna solo i pezzi cambiati
    setParam(params, "name", search);                  // keepEmpty:true se vuoi name=
    setParam(params, "order_by", newOrder);
    setParam(params, "direction", direction);

    // garantisci default di sort se mancano
    setDefaultSort(params);

    setQueryUrl(`${baseUrl}?${params.toString()}`);
  };

  const onChangeProfessionalFilter = (professionalId = "") => {
    const params = buildParamsFromUrl(queryUrl);

    // aggiorna solo professional_id, preservando tutto il resto
    setParam(params, "professional_id", professionalId);

    // default sort se mancano
    setDefaultSort(params);

    setQueryUrl(`${baseUrl}?${params.toString()}`);
  };

  // niente spazio hack: usa un timestamp per forzare il refresh
  const archiveReload = () => {
    const params = buildParamsFromUrl(queryUrl);
    params.set("_reload", Date.now().toString());
    setQueryUrl(`${baseUrl}?${params.toString()}`);
  };

  const renderPatientItem = useCallback((item) => {
    return (
      <PatientBox
        {...item}
        licenses={licenses}
        archiveRedirect={archiveReload}
        assignModal={assignModal}
      />
    );
  }, [licenses, assignModal, archiveReload]);

  return (
    <div className={style.PatientsList}>
      <div className={"row mb-4"}>
        <PatientListHeader
          createPatient={createPatient}
          onChangeFilter={onChangeFilter}
          onChangeProfessionalFilter={onChangeProfessionalFilter}
          searchSelectOptions={searchSelectOptions}
          searchPatientsPlaceholderText={searchPatientsPlaceholderText}
          supervisorMode={supervisorMode}
          supervisor={supervisor}
        />
      </div>

      {firstAccess.check ? (
        <FirstAccess {...firstAccess} />
      ) : (
        <div className={style.List}>
          <List baseQuery={queryUrl} renderItem={renderPatientItem} />
        </div>
      )}
    </div>
  );
}

export default Patients;
